import React from 'react';
import { Dialog, DialogTitle, DialogContent, Grid } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { StyledDialogActions } from 'components/DecisionDialog/styles';
import CloseIconBlack from 'components/SahamIcons/CloseIconBlack';

export interface DialogDecisionProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  title: string;
  content: any;
  disabled: boolean;
  primaryButtonTitle: any;
  scondaryButtonTitle: any;
}

const DialogDecision: React.FC<DialogDecisionProps> = (props): JSX.Element => {
  const { onClose, open } = props;

  return (
    <Dialog
      onClose={() => onClose()}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        <Grid container direction="row" spacing={3}>
          <Grid item xs={11}>
            {props.title}
          </Grid>
          <Grid item>
            <CloseIconBlack onClick={() => onClose()} />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>{props.content}</DialogContent>
      <StyledDialogActions>
        <SecondaryButton
          onClick={() => props.onClose()}
          disableElevation
          data-testId="cancel-button"
          title={props.scondaryButtonTitle}
        />
        <PrimaryButton
          onClick={() => props.validateDialog()}
          disableElevation
          data-testId="validate-button"
          title={props.primaryButtonTitle}
          disabled={props.disabled}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

DialogDecision.defaultProps = {
  open: false,
};

export default injectIntl(DialogDecision);
